import classNames from "classnames";
import uniqueId from "lodash/uniqueId";
import { DropdownOption } from "PFComponents/dropdown";
import { SelectV2 } from "PFComponents/select_v2";
import { Option } from "PFTypes/options";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import css from "./sort_by.module.scss";

type SortByProps = {
  className?: string;
  sort: string;
  options: DropdownOption[];
  noLabel?: boolean;
  dropdownMaxHeight?: number;
  disabled?: boolean;
  title?: string;
  onSortChange: (sort) => void;
};

const SortBy = ({
  className,
  sort,
  onSortChange,
  options,
  noLabel,
  dropdownMaxHeight,
  disabled,
  title
}: SortByProps) => {
  const { t } = useTranslation();

  // Just in case there is still some places where the sort text has not been updated
  const mappedOptions = options.map((item) => {
    if (item.id === "Term similarity") {
      return {
        ...item,
        displayElement: t("mostRelevant")
      };
    } else {
      return item;
    }
  });

  const selectOptions: Option<DropdownOption["item"]>[] = mappedOptions.map(
    ({ id, item, displayElement, disabled: optionDisabled }) => ({
      id,
      value: typeof displayElement === "string" ? displayElement : String(item),
      original: item,
      displayElement,
      disabled: optionDisabled
    })
  );

  const handleSortChange = (option: Option<DropdownOption["item"]>) => {
    const newSort = option.original;
    if (newSort !== sort) {
      onSortChange(newSort);
    }
  };

  const uniqId = useMemo(() => uniqueId("sortBy"), []);

  return (
    <SelectV2
      title={title}
      className={classNames(css.sortBySelect, className)}
      inline
      id={uniqId}
      label={noLabel ? undefined : t("sortBy")}
      onChange={(option) => handleSortChange(option as Option<DropdownOption["item"]>)}
      value={sort || undefined}
      placeholder={t("chooseAnOption")}
      options={selectOptions}
      disabled={disabled}
      dropdownMaxHeight={dropdownMaxHeight}
    />
  );
};

export default SortBy;
